export const FLYING_DESIGN_TRANSFER_CONFIG = {
	version: 1,
	grantLifetimeMs: 5 * 60 * 1000,
	sessionLifetimeMs: 7 * 24 * 60 * 60 * 1000,
	transferLifetimeMs: 24 * 60 * 60 * 1000,
	// Covers all records issued at ten grants per UTC day during a seven-day session,
	// including day-boundary overlap and the five-minute redemption window.
	maxListedDevices: 100,
	maxDesigns: 100,
	maxAssetBytes: 100 * 1024 * 1024,
	maxBatchBytes: 500 * 1024 * 1024,
	maxManifestBytes: 2 * 1024 * 1024,
	maxFlyIdLength: 120,
	maxDeviceLabelLength: 80
} as const;

export const FLYING_DESIGN_TRANSFER_API_PATH = '/design-transfers';
export const FLYING_UPLOADER_TRANSFER_API_PATH = '/uploader-transfers/v1';
